import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../App';
import { useLanguage } from '../LanguageContext';
import LanguageToggle from './LanguageToggle';
import './Layout.css';

function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const { t } = useLanguage();

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="layout">
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <div className="logo">
            <Link to="/dashboard">
              <h1>{t('common.appName')}</h1>
            </Link>
          </div>
          
          <nav className="nav">
            <Link 
              to="/dashboard" 
              className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
            >
              {t('layout.navDashboard')}
            </Link>
            <Link 
              to="/profile" 
              className={`nav-link ${location.pathname === '/profile' ? 'active' : ''}`}
            >
              {t('layout.navProfile')}
            </Link>
            <a 
              href="https://zlatarenta.com" 
              className="nav-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('layout.navShop')}
            </a>
          </nav>

          <div className="header-right">
            <LanguageToggle />
            <div className="user-info">
              <span className="user-email">{user?.email}</span>
              <span className={`user-status status-${user?.status || 'pending'}`}>
                {user?.verified ? '✓' : '⏳'}
              </span>
            </div>
            <button onClick={handleLogout} className="logout-btn">
              {t('layout.logout')}
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="main-content">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p>{t('layout.copyright', { year: new Date().getFullYear() })}</p>
          <div className="footer-links">
            <a href="https://zlatarenta.com/pages/kontakt" target="_blank" rel="noopener noreferrer">
              {t('layout.footerContact')}
            </a>
            <a href="https://zlatarenta.com/policies/terms-of-service" target="_blank" rel="noopener noreferrer">
              {t('layout.footerTerms')}
            </a>
            <a href="https://zlatarenta.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">
              {t('layout.footerPrivacy')}
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;

